// @flow
import * as React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {handleLogout} from "@store/actions/auth";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

export function LogOutModal(props) {
    const {isOpen, toggleModal} = props
    const dispatch = useDispatch()
    const navigate = useNavigate()
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggleModal}
            className="modal-dialog-centered modal-sm">
            <ModalHeader toggle={toggleModal} className='bg-danger text-white'>
              <span className='text-white'>
                   خروج از حساب
              </span>
            </ModalHeader>
            <ModalBody className="bg-white">
                آیا میخواهید خارج شوید؟
            </ModalBody>
            <ModalFooter>
                <Button className="btn-success" onClick={() => {
                    dispatch(handleLogout())
                    navigate("/")
                }}>
                    خروج
                </Button>
                <Button className="btn-danger" onClick={toggleModal}>
                    بستن
                </Button>
            </ModalFooter>
        </Modal>
    );
};